import _ from 'lodash'
import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import { Icon } from '@ant-design/compatible'
import { appStore } from '../../stores/appStore'
import { uaaCenter } from '../../uaaCenter'
import './CenterSidebar.less'

@observer
class CenterSidebar extends Component<ICenterSidebarProps, ICenterSidebarState> {

  private appListWrapRef: HTMLDivElement = null as any
  private appListRef: HTMLDivElement = null as any


  constructor(props: ICenterSidebarProps) {
    super(props)
    this.state = {
      enableAppListScrollArrow: false
    }
  }

  componentDidMount() {
    this.setCurrentSystemCode(this.props.location.pathname)
    window.addEventListener('resize', () => {
      this.checkAppListScroll()
    })
  }

  componentWillReceiveProps(nextProps: Readonly<ICenterSidebarProps>) {
    if (nextProps.location.pathname != this.props.location.pathname) {
      this.setCurrentSystemCode(nextProps.location.pathname)
    }
  }

  render() {
    let myUserData = appStore.myUserData || {}
    let apps = myUserData.navigatorGroupMenus && myUserData.navigatorGroupMenus.DEFAULT ? myUserData.navigatorGroupMenus.DEFAULT : myUserData.generalMenus
    let active = appStore.centerSidebarActive
    return (
      <div className={classNames('center-sidebar', { active: active })}>
        {!active && <MenuUnfoldOutlined className="menu-toggle" onClick={() => appStore.centerSidebarActive = true} />}
        {active && <MenuFoldOutlined className="menu-toggle" onClick={() => appStore.centerSidebarActive = false} />}
        <div className="app-list-wrap" ref={this.setAppListWrapRef}>
          {this.state.enableAppListScrollArrow && <div className="arrow-up" onClick={() => this.scrollUp()}><Icon type="up" /></div>}
          <div className="app-list" ref={this.subscribeScroll}>
            {
              apps.map(app => {
                return (
                  <div
                    key={app.customId} onClick={() => this.openApp(app.customId)}
                    className={classNames('app-item', { 'active': appStore.currentSystemCode == app.customId })}
                  >
                    <div className="icon">
                      <Icon type={app.icon || 'unordered-list'} />
                    </div>
                    <div className="title">{app.text}</div>
                  </div>
                )
              })
            }
          </div>
          {this.state.enableAppListScrollArrow && <div className="arrow-down" onClick={() => this.scrollDown()}><Icon type="down" /></div>}
        </div>
      </div>
    )
  }

  private setAppListWrapRef = (ref: HTMLDivElement) => {
    if (ref) {
      this.appListWrapRef = ref
      this.checkAppListScroll()
    }
  }
  private subscribeScroll = (ref: HTMLDivElement) => {
    if (ref && this.appListRef == null) {
      this.appListRef = ref
      this.checkAppListScroll()
      this.appListRef.addEventListener('mousewheel', (e: Event) => {
        let delta = (e as WheelEvent).deltaY
        if (delta >= 0) {
          this.scrollDown(delta)
        } else {
          this.scrollUp(Math.abs(delta))
        }
      })
    }
  }
  private checkAppListScroll = () => {
    if (this.appListRef && this.appListWrapRef) {
      let wrapRect = this.appListWrapRef.getClientRects()[0]
      this.setState({ enableAppListScrollArrow: this.appListRef.scrollHeight > wrapRect.height })
    }
  }
  private scrollUp = (offset: number = 120) => {
    if (this.appListRef) {
      this.appListRef.scrollTo({ top: this.appListRef.scrollTop - offset })
    }
  }
  private scrollDown = (offset: number = 120) => {
    if (this.appListRef) {
      this.appListRef.scrollTo({ top: this.appListRef.scrollTop + offset })
    }
  }

  private openApp = (code: string) => {
    appStore.centerSidebarActive = false
    if (code == uaaCenter.code) {
      this.props.history.push('/uaa/')
    } else {
      this.props.history.push('/system/' + code)
    }
  }

  private setCurrentSystemCode = (path: string) => {
    if (path.indexOf('/uaa') == 0 && appStore.currentSystemCode != uaaCenter.code) {
      appStore.currentSystemCode = uaaCenter.code
      return
    }
    if (path.indexOf('/system') == 0) {
      let systemCode = path.split('/')[2]
      console.log('systemCode.......', systemCode)
      if (systemCode != appStore.currentSystemCode) {
        if (appStore.getSystem(systemCode)) {
          appStore.currentSystemCode = systemCode
        }
      }
    }
  }

}

interface ICenterSidebarProps extends RouteComponentProps {

}

interface ICenterSidebarState {
  enableAppListScrollArrow: boolean
}

export default withRouter(CenterSidebar)
